import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/* ── Service Worker Registration ── */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then(registration => {
        window.swRegistration = registration;

        /* Listen for sw messages (e.g. sync timestamps) */
        navigator.serviceWorker.addEventListener('message', event => {
          if (event.data?.type === 'SYNC_TIMESTAMP') {
            localStorage.setItem('nel_last_sync', String(event.data.ts));
          }
        });

        /* Check for updates every 60 s */
        setInterval(() => registration.update(), 60_000);
      })
      .catch(err => console.warn('[SW] Registration failed:', err));
  });
}
